import { RouteLegTypeEnum, LegLocationTypeEnum, RouteLocationType, SegmentTypeEnum } from '@/api/apis/route';
import { CaseResourceType, OrganType } from '@/api/apis/case';
import { AircraftView } from '@/api/apis/resources';
import { WithExtendedLocation } from '@/utils/helpers';

export enum NodeConnection {
  toMainLeft = 'toMainLeft',
  toMainRight = 'toMainRight',
  toLeft = 'toLeft',
  toCenter = 'toCenter',
  toRight = 'toRight',
  fromMainLeft = 'fromMainLeft',
  fromMainRight = 'fromMainRight',
  fromLeft = 'fromLeft',
  fromCenter = 'fromCenter',
  fromRight = 'fromRight',
}

export type CombinedRouteLegType<T> = T & {
  segmentDurationInMs: number;
};

export type EdgeTransportInfoType = {
  time: string;
  legType: RouteLegTypeEnum;
  aircraft?: AircraftView;
  index?: number;
  isReposition?: boolean;
};

export type BaseLocationNode = {
  id: string;
  segmentId: string;
  segmentType: SegmentTypeEnum;
  locationType: LegLocationTypeEnum;
  locationId?: string;
  locationData?: WithExtendedLocation<RouteLocationType> | null;
  startTime?: string | null;
  endTime?: string | null;
  includeLocationIds: string[];
};

export type RouteParentNodeDataType = BaseLocationNode & {
  nodeType: 'parent';
  childrenTop?: number;
  childrenBottom?: number;
};

export type RouteChildNodeDataType = BaseLocationNode & {
  nodeType: 'child';
  parentId?: string | null;
  connectionType?: 'from' | 'to';
  resource?: CaseResourceType;
};

export type RouteNodeType<T = RouteParentNodeDataType> = {
  id: string;
  type: string;
  width: number;
  position: {
    x: number;
    y: number;
  };
  data: T & {
    title: string;
    organType: OrganType;
    schemaType: 'main' | 'alt';
  };
};
